module.exports = __webpack_public_path__ + "img/right-side-menu-filters-active.f6b51d39.svg";